export const school = {
  name: "Instituto Educacional Recriar",
  short: "Recriar",
  founded: "2019",
  address: "Rua Dr. Epitácio Pessoa, 94",
  whatsappRaw: "551144892319",
  whatsappDisplay: "(11) 4489-2319",
  instagram: "institutoeducacionalrecriar",
  instagramUrl: "https://instagram.com/institutoeducacionalrecriar",
  email: "institutoeducacionalrecriar@gmail.com",
  hours: "Seg a Sex · 6h30 às 19h",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_e32cbe93-7a89-4bb2-8028-eb591598087a/artifacts/7okq7cv9_recriar.png",
  googleRating: "4,9",
};

export const whatsappLink = (msg) =>
  `https://wa.me/${school.whatsappRaw}?text=${encodeURIComponent(msg || "Olá! Gostaria de saber mais sobre o Instituto Educacional Recriar.")}`;

export const heroVideo = "/media/hero.mp4";
export const heroPoster = "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/dagiunwu_foto_recriar_2000px.jpg";

export const images = {
  classroom: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/dagiunwu_foto_recriar_2000px.jpg",
  art: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/dagiunwu_foto_recriar_2000px.jpg",
  play: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/q84cs634_foto_recriar_05_2000px.jpg",
  playground: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/ml7uqyfl_foto_recriar_02_2000px.jpg",
  baby: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/y2diwy1i_foto_recriar_03_2000px.jpg",
  toys: "https://customer-assets-lxgj4vgw.emergentagent.net/job_instituto-recriar/artifacts/y2diwy1i_foto_recriar_03_2000px.jpg",
};

export const manifesto = [
  {
    n: "01",
    title: "Nascida da confiança",
    text: "Em 2019, após conhecer a escola por meio de uma professora, a atual responsável — mãe de duas crianças — assumiu a instituição movida pela confiança que tinha no espaço.",
  },
  {
    n: "02",
    title: "Vínculo que cresceu junto",
    text: "Seus próprios filhos estudaram aqui por alguns anos, fortalecendo o compromisso com um ambiente seguro, acolhedor e preparado para receber cada criança.",
  },
  {
    n: "03",
    title: "Dedicação constante",
    text: "Mesmo com as mudanças trazidas pela pandemia, permanecemos à frente da Recriar, cuidando da escola e construindo sua história com carinho e responsabilidade.",
  },
  {
    n: "04",
    title: "Educar é cuidar",
    text: "Hoje a Recriar carrega a essência de quem acredita que educar é acolher e oferecer às crianças um lugar onde possam aprender, crescer e se sentir seguras.",
  },
];

export const classes = [
  { name: "Berçário 1 e 2", age: "A partir de 4 meses", color: "brand-pink", desc: "Acolhimento, afeto e cuidado individualizado nos primeiros passos." },
  { name: "Maternal 1 e 2", age: "A partir de 2 anos", color: "brand-green", desc: "Rotina lúdica com material didático alinhado à BNCC." },
  { name: "Pré 1 e 2", age: "Rumo ao 1º ano", color: "brand-orange", desc: "Preparação para o Ensino Fundamental com autonomia e segurança." },
];

export const periods = [
  { name: "Manhã", icon: "Sunrise", color: "brand-yellow" },
  { name: "Tarde", icon: "Sun", color: "brand-orange" },
  { name: "Integral", icon: "Clock", color: "brand-sky" },
];

export const activities = [
  { name: "Inglês", icon: "Languages", color: "brand-sky" },
  { name: "Música", icon: "Music", color: "brand-pink" },
  { name: "Ballet", icon: "Sparkles", color: "brand-orange" },
  { name: "Alimentação", icon: "Apple", color: "brand-green" },
  { name: "Playground", icon: "TreePalm", color: "brand-yellow" },
  { name: "Extracurriculares", icon: "Palette", color: "brand-red" },
];

export const structure = [
  { name: "Área externa", icon: "Trees" },
  { name: "Refeitório", icon: "UtensilsCrossed" },
  { name: "Controle de entrada e saída", icon: "ShieldCheck" },
  { name: "Acessibilidade", icon: "Accessibility" },
];
